import React, { Component } from 'react';
import GlobalSearch from "~/ui/GlobalSearch/GlobalSearch";
import { AboutUs } from '~/ui/AboutUs/AboutUs';

const appBarDialogs = {
    search: GlobalSearch,
    aboutUs: AboutUs
};

export const appBarDialogClasses = {
    aboutUs: AboutUs.dialogClassName
}

export default appBarDialogs;